import { lazy } from "react";

export { INTERVIEW_PATH } from "./path";
export const InterviewPage = lazy(() => import("./page"));
